import React from 'react';
import { ApplicationStatusType, ApplicationStatusTypeOptions } from '@apply/constants';
import Accordion from 'devextreme-react/accordion';

export const ModalSummaryHeader = ({ application, expandReasons = false }) => {
    const styles = {
        noPaddingRight: { paddingLeft: '0' },
        padding10Bottom: { marginBottom: '10px' },
        nonEditable: { backgroundColor: '#f7f7f7', padding: '5px 10px' },
    };

    const getReasons = (reasons, title) => {
        if (!reasons || reasons.length === 0) {
            return [
                {
                    title,
                    reasons: ['No reasons recorded'],
                },
            ];
        }
        return [
            {
                title,
                reasons,
            },
        ];
    };

    const onTitleRender = (e) => {
        return <span style={{ fontSize: 'smaller' }}>{e.title}</span>;
    };

    const onReasonsRender = (e) => {
        const items = e.reasons.map((r, index) => {
            return <li key={'reason' + index}>{r}</li>;
        });
        return <ul style={{ marginBottom: '0' }}>{items}</ul>;
    };

    return (
        <div style={styles.nonEditable}>
            <h2 className='decorated'>Borrower Details</h2>
            <div
                className='row'
                style={styles.padding10Bottom}
            >
                <div className='columns small-12 large-6'>
                    <b>{application?.entityName}</b>
                    {(application?.street1 || application?.street2) && (
                        <>
                            <br /> {application?.street1} {application?.street2}
                        </>
                    )}{' '}
                    {(application?.city || application?.state || application.zipCode) && (
                        <>
                            <br /> {application?.city}, {application?.state} {application.zipCode}
                        </>
                    )}
                </div>
                <div
                    className='columns small-12 large-6'
                    style={styles.noPaddingRight}
                >
                    <b>{application?.contactName}</b>
                    {application?.contactEmail && <div>{application?.contactEmail}</div>}
                </div>
            </div>
            <h2 className='decorated'>Loan Type & BFI #</h2>
            <div
                className='row'
                style={styles.padding10Bottom}
            >
                <div
                    className='columns small-12 large-4'
                    style={styles.noPaddingRight}
                >
                    {application?.loanDescription}
                </div>
                {application?.bfiNumber && (
                    <div
                        className='columns small-12 large-8'
                        style={styles.noPaddingRight}
                    >
                        {application?.bfiNumber}
                    </div>
                )}
            </div>
            {(application?.statusId ?? 0) > 0 && (
                <>
                    <h2 className='decorated'>Application Status</h2>
                    <div
                        className='row'
                        style={styles.padding10Bottom}
                    >
                        <div
                            className='columns small-12 large-12'
                            style={styles.noPaddingRight}
                        >
                            <b>{ApplicationStatusTypeOptions.find((a) => a.id === application.statusId)?.name}</b>
                        </div>
                    </div>
                    {(application.statusId === ApplicationStatusType.IncompleteFile ||
                        application.statusId === ApplicationStatusType.Lost_DeclinedByBfi) && (
                        <div>
                            <Accordion
                                dataSource={getReasons(
                                    application.lostReasons,
                                    application.statusId === ApplicationStatusType.IncompleteFile
                                        ? 'Reasons for Closing File'
                                        : 'Reasons for Decline'
                                )}
                                collapsible={!expandReasons}
                                itemTitleRender={onTitleRender}
                                itemRender={onReasonsRender}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
